import styled from 'styled-components';
import StyledBtnGeneric from './StyledBtnGeneric';
import withButtonProps from './withButtonProps';

const BtnRaised = styled(StyledBtnGeneric)`
  box-shadow: inset 0px -6px 0px ${props => props.shadowColor};
  padding-bottom: 6px;
  line-height: calc(var(--btn-height) - 6px);

  svg {
    margin-bottom: 6px;
  }
`;

export default withButtonProps(BtnRaised);
